// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"b92ce307","151":"443100b1","453":"7311d671","691":"c2257478","708":"aab54e1a"}[chunkId] + ".chunk.js";
};